module.exports = __webpack_public_path__ + "img/OnlyCloud_Color.2608da15.png";